import { connectedStore } from '../../store';
import actions from '../actions';

const clientUploadAssets = (assets) =>
  new Promise((resolve, reject) => {
    const store = connectedStore.get();
    store.dispatch(actions.clientUploadAssets(assets, resolve, reject));
  });

export default clientUploadAssets;
